import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Check from "../assets/check";
import { useNotifcication } from "../hooks/useNotification";
import cn from "../lib/utils/class-name";
import CircleCancel from "../assets/circleCancel";

export default function PopUp() {
  const { message, isOpen, status, closeNotification } = useNotifcication();

  useEffect(() => {
    if (isOpen) setTimeout(closeNotification, 3000);
  }, [isOpen]);
  return (
    isOpen && (
      <div className="fixed top-[20px] z-[99999] right-[20px]">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div
            className={cn(
              "shadow-lg min-w-[150px] rounded-lg text-primary-dark px-[12px] py-[6px]",
              status === "success" ? "bg-green-500" : "bg-red-400"
            )}
          >
            <div className="flex flex-row h-full items-center gap-[5px]">
              {status === "success" && (
                <Check className={"size-[25px]  fill-white"} />
              )}
              {status === "error" && (
                <CircleCancel className={"size-[25px]  fill-white"} />
              )}
              <p className="font-switzer text-[12px] text-white ">{message}</p>
            </div>
          </div>
        </motion.div>
      </div>
    )
  );
}
